import { FC, ReactNode } from 'react'

import './SettingsCardTitle.scss'

interface Props {
    title: string;
    children?: ReactNode;
}

export const SettingsCardTitle:FC<Props> = ({
    title,
    children,
}) => (
    <div className={`settings-card-title ${children ? 'settings-card-title--has-children' : ''}`}>
        {title}
        {children}
    </div>
)
